import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useIdleLogout } from '../hooks/useIdleLogout'

const IdleLogoutGuard = () => {
    const { warningOpen, secondsLeft, stayLoggedIn } = useIdleLogout()

    return (
        <Dialog open={warningOpen} onClose={stayLoggedIn}>
            <DialogTitle>Automatische Abmeldung</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Sie waren längere Zeit inaktiv und werden in {secondsLeft} Sekunden
                    automatisch abgemeldet.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={stayLoggedIn}>
                    Angemeldet bleiben
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default IdleLogoutGuard
